// extracted by mini-css-extract-plugin
module.exports = {"squareButton":"_1d79e51","text":"_72371d7"};